import React, {useState, useEffect}from 'react';
import './Dashboard.css';
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from 'axios';

function Dashboard() {
    const [dealDetails, setDealdetails] = useState([]);
    const [isLoading, setIsLoading] = useState([true]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [isEmail, setIsEmail] = useState();
     const [user, setUser] = useState(null);

    useEffect(() => {
      console.log("data called");
      const fetchUserSession = async () => {
        try {
          const response = await axios.get("/server/subscription/session");
          setUser(response.data);
          console.log("user", response.data); 
          if (response.data) {
            const firstName = response.data.first_name || "";
            const lastName = response.data.last_name === "N/A" ? "" : response.data.last_name || "";
            const username = `${firstName} ${lastName}`.trim();
            // const username = `${response.data.first_name || ""} ${response.data.last_name || ""}`.trim();
            const useremail_id = response.data.email_id || "";
            const useraddress = response.data.locale || "";
            const user_id = response.data.user_id||"";
            sessionStorage.setItem("userName", username);
            sessionStorage.setItem("userEmail", useremail_id);
            sessionStorage.setItem("user_id",user_id);
          }
        } catch (error) {
          console.error("Error fetching user session:", error);
        }
      };
    
      fetchUserSession();
    }, []);

    const username = user?.first_name+' ' + user?.last_name;
    const useremail_id = user?.email_id;
    const useraddress = user?.locale;
    sessionStorage.removeItem("transactionId");
    sessionStorage.removeItem("subscription_id");
   
    useEffect(() => {
      if (!useremail_id) return; 
      setIsLoading(true);
        axios
          .get(`/server/subscription/customer/dealList/${useremail_id}`)
          .then((response) => {
            const DealDetails = response.data.data['Deal details'];
            console.log("dealDetails",DealDetails);
            
            const dealItems = DealDetails.map((deals=>{
                const dealName  = deals.Deal_Name;
                const WaqfName = deals.Waqf?.name||"";
                const waqf_id = deals.Waqf.id;
                const amount = deals.Amount;
                const transactionId= deals.Transaction.id;   
                console.log("transactionId",transactionId); 
                return{
                    dealName:dealName ? dealName:"",
                    WaqfName:WaqfName? WaqfName:"",
                    waqf_id :waqf_id,
                    amount: amount,
                    dealAmount : amount ? `$${amount}` : "",
                    transactionId:transactionId
                }
            }))
            const totalAmount = dealItems.reduce((sum, deal) => sum + Number(deal.amount), 0);
            setTotalAmount(`$${totalAmount.toLocaleString()}`);
            setDealdetails(dealItems);
          })
        
          .catch((error) => console.error('Error fetching subscription data:', error))
          .finally(() => setIsLoading(false));
      }, [useremail_id]);

    useEffect(()=>{
        console.log("DealDetails",dealDetails);
    },[dealDetails])

    console.log("totalamount",totalAmount);

      const navigate = useNavigate();
  
    const handlePageNavigation = (email_id, waqf_id,dealName) => {
      // sessionStorage.setItem("parentPage",Dashboard);
      navigate(`/WaqfDetails`, {
        state: { email_id, waqf_id, dealName,parentPage:"dashboard"},
      });
    };

    sessionStorage.removeItem("parentPage");

  return (
      <div className="bg-[#F7F7F7] -m-[23px] p-[30px] pl-[45px] min-h-screen pr-[45px] flex flex-col no-scrollbar max-sm:block">
           {isLoading && (
            <div className="absolute inset-0 flex h-250vh justify-center items-center bg-white bg-opacity-75 z-50 fixed">
              <div className="animate-spin w-12 h-12 border-[4px] rounded-full border-l-[#095856] border-black"></div>
            </div>
          )}
            <div class="bordercolor flex flex-wrap mb-2 mt-2 w-[100%] h-112px max-sm:block" >
            <div class=" p-2  max-sm:p-1">
              <div class="dashboardCard">
                <div class="p-4 dashboardCardContent h-[112px] gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
                  <h6 class="dashboardCardPay">
                    {totalAmount}
                    </h6>
                  <p class="dashboardCardvalue font-[600]">Waqf Donations</p>
                </div>
              </div>
            </div>
            <div class="p-2 max-sm:p-1">
              <div class="bg-white shadow-lg rounded-lg dashboardCard">
                <div class="p-4 dashboardCardContent h-[112px] gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
                  <h6 class="text-lg font-bold dashboardCardPay">
                  {totalAmount}
                    </h6>
                  <p class="dashboardCardvalue font-[600]">Current Donation Value</p>
                </div>
              </div>
            </div>
            <div class="p-2  max-sm:p-1">
              <div class="bg-white shadow-lg rounded-lg dashboardCard">
                <div class="p-4 dashboardCardContent h-[112px]  gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
                  <h6 class="text-lg font-bold dashboardCardPay">
                    $0
                    </h6>
                  <p class="dashboardCardvalue font-[600]">Total Granted</p>
                </div>
              </div>
            </div>
          </div>
    
<div className="bordercolor -mb-[24px]">
      <div className="WaqfsDiv">
        <h6 className="WaqfsTypo p-2">
          Waqfs Supported
        </h6>
        {dealDetails.length > 0 ? (
           dealDetails.map((item, index) => (
          <ul className="list-none  pl-4 bg-[white] z-10">
           
              <li
                key={index}
                className="WaqfsLi font-Jost mb-[3px] cursor-pointer text-[16px] text-[#0E5C57] flex items-center gap-10 max-sm:flex-col max-sm:items-start max-sm:gap-1 relative pb-2"
                onClick={() => handlePageNavigation(useremail_id, item.waqf_id, item.WaqfName)}
              >
                <div className='flex flex-1 justify-start items-center max-sm:flex-row'>
                <span className="w-1.5 h-1.5 rounded-full bg-[#0E5C57] mr-2"></span>
                <span className="font-500 font-medium">{item.WaqfName}</span>
                </div>
                <span className="text-black flex-2 ml-2 max-sm:ml-5  font-400">{item.dealAmount}</span>
              </li>
           
          </ul>
        ))
        ) : (
          <p className="text-center text-gray-500 mt-5 mr-60 max-sm:mr-8">No Items found.</p>
        )}
      </div>
    </div>
  </div>
  )
}

export default Dashboard;
